import React from 'react';
import CalculusOfProgress from '../components/CalculusOfProgress';

function CalculusOfProgressPage() {
  return <CalculusOfProgress />;
}

export default CalculusOfProgressPage;
